'use client';
import { AnchorHTMLAttributes, PropsWithChildren } from 'react';
import { cn } from '@ecom/helper-react-class-combine';
import { Link, type LinkProps } from '@/shared/components/primitives/link';

type TextNavLinkProps = {
  href: string;
  onClick?: () => void;
  prefetch?: LinkProps['prefetch'];
  prefetchOnHover?: boolean;
  className?: string;
  ariaLabel?: string;
  isUnderline?: boolean;
  isBold?: boolean;
  target?: '_self' | '_blank' | '_parent' | '_top';
  rel?: string;
};

/** `Link` in the site's nav/footer text style. */
export const TextNavLink = ({
  href,
  children,
  onClick,
  className,
  ariaLabel,
  isUnderline = false,
  isBold = false,
  prefetch,
  prefetchOnHover = false,
  target,
  rel,
  ...rest
}: PropsWithChildren<
  TextNavLinkProps & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'popover'>
>) => (
  <Link
    href={href}
    prefetch={prefetch}
    prefetchOnHover={prefetchOnHover}
    className={cn(
      'text-m transition-colors',
      'focus-visible:ring-primary lg:hover:text-text-hover focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2',
      isUnderline ? 'underline' : '',
      isBold ? 'font-semibold' : '',
      className,
    )}
    onClick={onClick}
    aria-label={ariaLabel}
    target={target}
    rel={rel}
    {...rest}
  >
    {children}
  </Link>
);
